var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configSetting.payTypes
    ? _c(
        "basic-container",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isInitLoading,
              expression: "isInitLoading",
            },
          ],
          attrs: { block: _vm.isInitLoading },
        },
        [
          _c("PayResult", {
            attrs: {
              "insure-type": _vm.insureType,
              "is-add": false,
              "is-pay-loading": _vm.isPayLoading,
              "order-id": _vm.orderId,
              "pay-source": 2,
              "pay-types-data": _vm.configSetting.payTypes || [],
              "pre-pay-notice-data": _vm.configSetting.prePayNotice,
              "product-id": _vm.productId,
              "source-product-id": _vm.sourceProductId,
              "temp-order-id": _vm.orderId,
              "is-close-tag": true,
              "total-price": _vm.totalPremium,
            },
            on: {
              "update:isPayLoading": function ($event) {
                _vm.isPayLoading = $event
              },
              "update:is-pay-loading": function ($event) {
                _vm.isPayLoading = $event
              },
              onPayAgain: _vm.onOpenToPay,
              onToPolicyDetail: _vm.onToPolicyDetail,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }